var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93377 11.9641L17.5123 11.9694C17.7112 11.9694 17.902 11.8904 18.0426 11.7497C18.1833 11.6091 18.2623 11.4183 18.2623 11.2194C18.2623 11.0205 18.1833 10.8297 18.0426 10.689C17.902 10.5484 17.7112 10.4694 17.5123 10.4694L5.94652 10.4641L8.13128 8.28012C8.27188 8.13947 8.35087 7.94874 8.35087 7.74987C8.35087 7.551 8.27188 7.36026 8.13128 7.21962C7.99063 7.07901 7.7999 7.00003 7.60102 7.00003C7.40215 7.00003 7.21142 7.07901 7.07077 7.21962L4.65952 9.62787C4.45044 9.83682 4.28457 10.0849 4.17141 10.358C4.05825 10.6311 4 10.9238 4 11.2194C4 11.515 4.05825 11.8077 4.17141 12.0807C4.28457 12.3538 4.45044 12.6019 4.65952 12.8109L7.06852 15.2191C7.20917 15.3597 7.3999 15.4387 7.59877 15.4387C7.79765 15.4387 7.98838 15.3597 8.12903 15.2191C8.26963 15.0785 8.34862 14.8878 8.34862 14.6889C8.34862 14.49 8.26963 14.2993 8.12903 14.1586L5.93377 11.9641Z",
    fill: "#26445A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo);
export default __webpack_public_path__ + "static/media/Go.aec8149a1f0a5a3ec92920a005ba122d.svg";
export { ForwardRef as ReactComponent };